import { render } from "./CtaBlock.vue?vue&type=template&id=4b944098&scoped=true"
import script from "./CtaBlock.vue?vue&type=script&lang=js"
export * from "./CtaBlock.vue?vue&type=script&lang=js"

import "./CtaBlock.vue?vue&type=style&index=0&id=4b944098&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b944098"]])

export default __exports__